import { render, staticRenderFns } from "./MainMenu.vue?vue&type=template&id=6b064ff6&scoped=true"
import script from "./MainMenu.vue?vue&type=script&lang=js"
export * from "./MainMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b064ff6",
  null
  
)

export default component.exports